// | First order discount wizard in cart
import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dTimer from "../Effect.Timer/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dWidgets$dBootstrap from "../Restaumatic.Form.Widgets.Bootstrap/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dRestaurants$dRPC$dSites$dTypes from "../Restaumatic.Restaurants.RPC.Sites.Types/index.js";
import * as Restaumatic$dServices$dFirstOrderDiscount$dBackend from "../Restaumatic.Services.FirstOrderDiscount.Backend/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFormField from "../Specular.FormField/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const holdDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
const parsedPhoneIsSymbol = {reflectSymbol: () => "parsedPhone"};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const fullNameIsSymbol = {reflectSymbol: () => "fullName"};
const emailIsSymbol = {reflectSymbol: () => "email"};
const getJSONItem1 = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.getJSONItem()({
  decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(parsedPhoneIsSymbol)(decodeWithOptionsOther)())(fullNameIsSymbol)(decodeWithOptionsOther)())(emailIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
}))();
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const setJSONItem1 = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.setJSONItem()({
  encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(parsedPhoneIsSymbol)(encodeWithOptionsOther))(fullNameIsSymbol)(encodeWithOptionsOther))(emailIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
}))();
const rsequence = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(emailIsSymbol)()(Restaumatic$dForm$dFinal.applyFinal)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "phone"
})()(Restaumatic$dForm$dFinal.applyFinal)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "restaurantId"})()(Restaumatic$dForm$dFinal.applyFinal)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle({
  reflectSymbol: () => "streetAddress"
})()(Restaumatic$dForm$dFinal.functorFinal)()())()())()())()());
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const textField = /* #__PURE__ */ Restaumatic$dForm$dWidgets$dBootstrap.textField(Restaumatic$dForm$dInternal.hasErrorsOldFormField)(Restaumatic$dForm$dWidgets$dBootstrap.labelString)(Restaumatic$dForm$dInternal.isTextFieldFormFieldStrin)({
  getFieldId: v => ""
})()();
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Specular$dInternal$dRIO.applicativeRIO)(Data$dMap$dInternal.foldableMap);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidString)(Data$dFoldable.identity))();
const identity = x => x;
const performEvent = /* #__PURE__ */ Specular$dFRP$dAsync.performEvent(monadFRP);
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const domEvent = /* #__PURE__ */ Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP)(v => () => {});
const getJSONItem2 = /* #__PURE__ */ Restaumatic$dServices$dStorage.getJSONItem()(Foreign$dGeneric$dClass.booleanDecode);
const wrapper = fadeOutEvent => content => Specular$dInternal$dRIO.bindImpl(holdDyn(false)(Specular$dFRP$dBase.functorEvent.map(v => true)(fadeOutEvent)))(fadeOutAnim => Specular$dDom$dElement.el("li")([
  Specular$dDom$dElement.class_("item promotion"),
  Specular$dDom$dElement.classWhenD(fadeOutAnim)("animated fadeOut")
])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("cart-multi-column mobile")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("column info")
])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("name")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.first_order_discount.wizard.header),
  {}
))))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-fod-description animated fadeIn")])(content))))(result => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("column quantity")
])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("column subtotal")])(Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(0))))(() => Specular$dInternal$dRIO.pureImpl(result)))))));
const wrapForm = content => Specular$dDom$dElement.el("form")([Specular$dDom$dElement.class_("m-form"), Specular$dDom$dElement.attr("onsubmit")("event.preventDefault();")])(content);
const updateUser = email => phone => {
  const $0 = getJSONItem1(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)("user");
  return () => {
    const a$p = $0();
    return setJSONItem1(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)("user")({
      email: Data$dMaybe.$Maybe("Just", email),
      fullName: Data$dMaybe.$Maybe(
        "Just",
        (() => {
          if (a$p.tag === "Nothing") { return ""; }
          if (a$p.tag === "Just") {
            if (a$p._1.fullName.tag === "Nothing") { return ""; }
            if (a$p._1.fullName.tag === "Just") { return a$p._1.fullName._1; }
            $runtime.fail();
          }
          $runtime.fail();
        })()
      ),
      parsedPhone: Data$dMaybe.$Maybe("Just", phone)
    })();
  };
};
const toFinal = restaurantId => v => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Restaumatic$dRestaurants$dRPC$dSites$dTypes.ClaimFODRequest))(rsequence({
  email: Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Specular$dFormField.fromValidV)(v.emailField.finalValue)),
  phone: Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Specular$dFormField.fromValidV)(v.phoneField.finalValue)),
  streetAddress: Restaumatic$dForm$dFinal.applicativeFinal.pure(Data$dMaybe.Nothing),
  restaurantId: Restaumatic$dForm$dFinal.applicativeFinal.pure(restaurantId)
}));
const successView = storage => time => success => Specular$dInternal$dRIO.bindImpl(newEvent)(fadeOutEvent => wrapper(fadeOutEvent.event)(Specular$dInternal$dRIO.bindImpl(newEvent)(v => {
  const $0 = v.event;
  return Specular$dInternal$dRIO.bindImpl((() => {
    if (success.tag === "Just") {
      return Specular$dInternal$dRIO.bindImpl(updateUser(success._1._1)(success._1._2))(() => Specular$dInternal$dRIO.bindImpl(storage._2("claimedFod")(Foreign$dInternal$dStringify.unsafeStringify(true)))(() => Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.class_("alert alert-success")
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.first_order_discount.wizard.coupon_sent),
        {}
      )))));
    }
    if (success.tag === "Nothing") {
      return Specular$dInternal$dRIO.bindImpl(storage._2("claimedFod")(Foreign$dInternal$dStringify.unsafeStringify(false)))(() => Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.class_("alert alert-warning")
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.first_order_discount.wizard.coupon_denied),
        {}
      ))));
    }
    $runtime.fail();
  })())(() => Specular$dInternal$dRIO.bindImpl(Effect$dTimer.setTimeoutImpl(time - 1000 | 0)((() => {
    const $1 = fadeOutEvent.fire();
    return () => {
      $1();
      Effect$dTimer.setTimeoutImpl(1000)(v.fire())();
    };
  })()))(() => Specular$dInternal$dRIO.pureImpl($0)));
})));
const initialView = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const bind2 = Monad0.Bind1().bind;
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newRef = Specular$dRef.new(MonadEffect0);
  const newFormFieldE = Specular$dFormField.newFormFieldE(dictMonadFRP);
  const pure3 = Monad0.Applicative0().pure;
  return bind2(Specular$dCallback.newCallback()(MonadEffect0))(submit => bind2(newRef(Data$dMap$dInternal.Leaf))(remoteErrors => {
    const $0 = submit.event;
    const $1 = remoteErrors._1;
    return bind2(newFormFieldE(Specular$dFormField.emailConversion(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.validations.invalid_email),
      {}
    )))({remoteErrors: Specular$dFRP$dBase.functorDynamic.map(Specular$dFormField.atPath(["email"]))($1), submitOccured: $0})(""))(emailField => bind2(newFormFieldE(Specular$dFormField.phoneConversion(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.validations.invalid_phone),
      {}
    )))({remoteErrors: Specular$dFRP$dBase.functorDynamic.map(Specular$dFormField.atPath(["phone"]))($1), submitOccured: $0})(""))(phoneField => bind2(newRef(false))(success => pure3({
      emailField,
      phoneField,
      submit: submit.callback,
      submitEvent: submit.event,
      success,
      remoteErrors
    }))));
  }));
};
const initialView1 = /* #__PURE__ */ initialView(monadFRP);
const emptyView = /* #__PURE__ */ Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.never);
const dialogView = v => wrapper(Specular$dFRP$dBase.never)(wrapForm(Specular$dInternal$dRIO.bindImpl(textField({
  props: [
    Specular$dDom$dElement.attr("type")("email"),
    Specular$dDom$dElement.attr("required")(""),
    Specular$dDom$dElement.attr("autocomplete")("email"),
    Specular$dDom$dElement.attr("data-testid")("FOD/email")
  ],
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.user.email), {}),
  field: v.emailField
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  props: [
    Specular$dDom$dElement.attr("type")("tel"),
    Specular$dDom$dElement.attr("required")(""),
    Specular$dDom$dElement.attr("autocomplete")("tel"),
    Specular$dDom$dElement.attr("data-testid")("FOD/phone")
  ],
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.user.phone), {}),
  field: v.phoneField
}))(() => Specular$dInternal$dRIO.bindImpl(dynamic_(Specular$dFRP$dBase.functorDynamic.map(errs => Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("alert alert-danger"),
  (() => {
    const go = (z$p, m$p) => {
      if (m$p.tag === "Leaf") { return z$p; }
      if (m$p.tag === "Node") { return go(1 + go(z$p, m$p._5) | 0, m$p._6); }
      $runtime.fail();
    };
    return go(0, errs) === 0;
  })()
    ? Specular$dDom$dElement.attr("style")("display: none;")
    : Specular$dDom$dElement.monoidProp.mempty
])(Specular$dDom$dElement.el("ul")([Specular$dDom$dElement.class_("list-unstyled")])(traverse_(err => Specular$dDom$dElement.el_("li")(Specular$dDom$dElement.text(fold(err))))(errs))))(v.remoteErrors._1)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.class_("btn btn-default"),
  Specular$dDom$dElement.attr("type")("submit"),
  Specular$dDom$dElement.attr("data-testid")("FOD/submit"),
  Specular$dDom$dElement.onClick_(v.submit())
])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.first_order_discount.wizard.send_button),
  {}
))))(() => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.attachDynWith(emph => result => {
  if (result) { return Data$dMaybe.$Maybe("Just", emph); }
  return Data$dMaybe.Nothing;
})(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dTuple.Tuple)(v.emailField.editRef._1))(v.phoneField.editRef._1))(v.success._1))))))));
const convertErrors = /* #__PURE__ */ (() => {
  const $0 = Data$dMap$dInternal.fromFoldableWith(Data$dOrd.ordArray(Data$dOrd.ordString))(Data$dFoldable.foldableArray)(Data$dSemigroup.concatArray);
  const $1 = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(v.path, [v.message]));
  return x => $0($1(x));
})();
const dialogWidget = v => {
  const $0 = v.restaurantId;
  return Specular$dInternal$dRIO.bindImpl(initialView1)(viewData => Specular$dInternal$dRIO.bindImpl(dialogView(viewData))(result => Specular$dInternal$dRIO.bindImpl(performEvent(Specular$dFRP$dBase.functorEvent.map(req => Effect$dAff._map(v2 => {
    if (v2.tag === "Left") { return Data$dEither.$Either("Left", []); }
    if (v2.tag === "Right") { return v2._1; }
    $runtime.fail();
  })(Restaumatic$dServices$dFirstOrderDiscount$dBackend.fodBackend.claimFOD(req)))(Specular$dFRP$dBase.filterMapEvent(identity)(Specular$dFRP$dBase.sampleAt(Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dFRP$dBase.identity)(viewData.submitEvent))(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(toFinal($0)(viewData)))))))(responseE => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(response => {
    if (response.tag === "Right") {
      const $1 = response._1;
      const $2 = viewData.success._2(_old => $1);
      return () => {
        $2();
        return viewData.remoteErrors._2(_old => Data$dMap$dInternal.Leaf)();
      };
    }
    if (response.tag === "Left") {
      const $1 = convertErrors(response._1);
      return viewData.remoteErrors._2(_old => $1);
    }
    $runtime.fail();
  })(responseE))(() => Specular$dInternal$dRIO.pureImpl(result)))));
};
const callToActionView = /* #__PURE__ */ (() => wrapper(Specular$dFRP$dBase.never)(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el$p("a")([
  Specular$dDom$dElement.attr("data-testid")("FOD/begin")
])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.first_order_discount.wizard.claim_button),
  {}
))))(v => domEvent("click")(v._1))))();
const wizardWidget = cfg => {
  const runWizard = Specular$dInternal$dRIO.mapImpl(v => {})(Specular$dFRP$dExtra.chain(Specular$dFRP$dExtra.chain(Specular$dFRP$dExtra.chain(callToActionView)(v => dialogWidget(cfg)))(successView(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)(10000)))(v => emptyView));
  return Specular$dInternal$dRIO.bindImpl(getJSONItem2(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)("claimedFod"))(fodClaimed => {
    if (fodClaimed.tag === "Just") {
      if (fodClaimed._1) { return Specular$dInternal$dRIO.pureImpl(); }
      return runWizard;
    }
    return runWizard;
  });
};
const runWizardWidget = v => {
  if (v.fodEnabled) { return wizardWidget(v); }
  return Specular$dInternal$dRIO.pureImpl();
};
export {
  callToActionView,
  convertErrors,
  decodeWithOptionsOther,
  dialogView,
  dialogWidget,
  domEvent,
  dynamic_,
  emailIsSymbol,
  emptyView,
  encodeWithOptionsOther,
  fold,
  fullNameIsSymbol,
  getJSONItem1,
  getJSONItem2,
  holdDyn,
  identity,
  initialView,
  initialView1,
  monadFRP,
  newEvent,
  parsedPhoneIsSymbol,
  performEvent,
  rsequence,
  runWizardWidget,
  setJSONItem1,
  subscribeEvent_,
  successView,
  textField,
  toFinal,
  traverse_,
  updateUser,
  wizardWidget,
  wrapForm,
  wrapper
};
